import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.component === curr.component && future.routeConfig?.data && future.routeConfig?.data['shouldReuse'] === false
      ? false : super.shouldReuseRoute(future, curr);
  }
}
